export enum SeasonStageTableColumns {
  AbbreviationLatin = "abbreviationLatin",
  AbbreviationLocal = "abbreviationLocal",
  ExternalId = "externalId",
  NameLatin = "nameLatin",
  NameLocal = "nameLocal",
  StageCode = "stageCode",
  StageOrder = "stageOrder",
}
